import React, { useEffect, useMemo } from "react";
import { usePlatformAdmin } from "context/PlatformAdminContext";
import {
  PLATFORM_ADMIN_CHROME_BODY_CLASS,
  PLATFORM_TENANT_CHROME_HEIGHT_PX,
  computePlatformAdminChromeHeight,
} from "context/platformAdminContext.utils";
import GhostModeBanner from "./GhostModeBanner";
import PlatformTenantBar from "./PlatformTenantBar";

const PlatformAdminChrome = () => {
  const { isInTenantContext, isGhostActive } = usePlatformAdmin();

  const chromeHeight = useMemo(
    () =>
      computePlatformAdminChromeHeight({
        showAccent: isInTenantContext || isGhostActive,
        showGhostBanner: isGhostActive,
        showTenantBar: isInTenantContext && !isGhostActive,
      }),
    [isGhostActive, isInTenantContext]
  );

  useEffect(() => {
    if (chromeHeight <= 0) {
      document.body.classList.remove(PLATFORM_ADMIN_CHROME_BODY_CLASS);
      document.body.style.removeProperty("--platform-admin-chrome-height");
      document.body.style.removeProperty("--platform-tenant-chrome-height");
      return undefined;
    }

    document.body.classList.add(PLATFORM_ADMIN_CHROME_BODY_CLASS);
    document.body.style.setProperty(
      "--platform-admin-chrome-height",
      `${chromeHeight}px`
    );
    document.body.style.setProperty(
      "--platform-tenant-chrome-height",
      `${PLATFORM_TENANT_CHROME_HEIGHT_PX}px`
    );

    return () => {
      document.body.classList.remove(PLATFORM_ADMIN_CHROME_BODY_CLASS);
      document.body.style.removeProperty("--platform-admin-chrome-height");
      document.body.style.removeProperty("--platform-tenant-chrome-height");
    };
  }, [chromeHeight]);

  if (chromeHeight <= 0) {
    return null;
  }

  const showAccent = isInTenantContext || isGhostActive;

  return (
    <div className="fixed inset-x-0 top-0 z-[10001]">
      {showAccent ? (
        <div className="h-1 bg-indigo-600" aria-hidden="true" />
      ) : null}
      {isGhostActive ? <GhostModeBanner /> : null}
      {isInTenantContext && !isGhostActive ? <PlatformTenantBar /> : null}
    </div>
  );
};

export default PlatformAdminChrome;
